/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:23
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    initialize() {
    }

    connect() {
      var resumeid = this.data.get("resumeid");
      // console.log("-=> resumecfg_controller connected (" + resumeid + ")");
      this.reload_activated();
    }

    reload_activated() {
      var resumeid = this.data.get("resumeid");
      $.get( "/resumes/" + resumeid + "/tag_selector", function( data ) {
        $( "#piece-preview" ).html( data );
      });
    }

    // ==== INCLUDE/EXCLUDE/IGNORE BUTTONS ====

    include_radio() {
      var tagid = event.currentTarget.dataset['resumecfgTagid'];
      var resumeid = this.data.get("resumeid");
      $.get( "/resumes/" + resumeid + "/tag_selector?state=include&tid=" + tagid, function( data ) {
        $( "#piece-preview" ).html( data );
      });
    };

    clear_radio() {
      var tagid = event.currentTarget.dataset['resumecfgTagid'];
      var resumeid = this.data.get("resumeid");
      $.get( "/resumes/" + resumeid + "/tag_selector?state=clear&tid=" + tagid, function( data ) {
        $( "#piece-preview" ).html( data );
      });
    };

    exclude_radio() {
      var tagid = event.currentTarget.dataset['resumecfgTagid'];
      var resumeid = this.data.get("resumeid");
      $.get( "/resumes/" + resumeid + "/tag_selector?state=exclude&tid=" + tagid, function( data ) {
        $( "#piece-preview" ).html( data );
      });
    };


    // ==== START/END DATE BUTTONS ====

    resume_start_date() {
      console.log('start changed');
      var dval = event.currentTarget.value;
      var resumeid = this.data.get("resumeid");
      if (!dval) {
        $("#start_null_message").removeClass('cloaked');
      } else { 
        $("#start_null_message").addClass('cloaked');
      }
      $.get( "/resumes/" + resumeid + "/set_date?f=start&d=" + dval, function( data ) {
        $( "#piece-preview" ).html( data );
      });
    }

    resume_end_date() {
      console.log('end changed');
      var dval = event.currentTarget.value;
      var resumeid = this.data.get("resumeid");
      if (!dval) {
        $("#end_null_message").removeClass('cloaked');
      } else { 
        $("#end_null_message").addClass('cloaked');
      }
      $.get( "/resumes/" + resumeid + "/set_date?f=end&d=" + dval, function( data ) {
        $( "#piece-preview" ).html( data );
      });
    }


  };

// console.log("-=> resumecfg_controller loaded");

